document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('[data-offer-test]');
  if (!root) return;
  const config = JSON.parse(document.querySelector('[data-offer-test-config]').textContent);
  const marketForm = document.getElementById('BrowMarketSelector');
  const marketCountry = document.getElementById('BrowMarketCountry');
  if (marketForm && marketCountry) {
    marketCountry.addEventListener('change', () => {
      marketForm.setAttribute('aria-busy', 'true');
      marketForm.requestSubmit();
    });
    marketForm.querySelector('button[type="submit"]').hidden = true;
  }
  const order = new globalThis.BrowisoCheckout(config);
  const choices = [...root.querySelectorAll('[data-offer-choice]')];
  const cards = [...root.querySelectorAll('[data-source-offer]')];
  const shades = ['cool_taupe', 'cool_taupe', 'cool_taupe'];
  const inputs = [...root.querySelectorAll('[data-offer-shade]')];
  const sticky = document.querySelector('[data-source-sticky-atc]');
  const stickySubmit = sticky?.querySelector('[data-sticky-submit]');
  const stickyError = sticky?.querySelector('[data-sticky-error]');
  const form = root.querySelector('[data-offer-test-form]');
  const atc = root.querySelector('[data-offer-add]');
  const error = document.createElement('p');
  error.className = 'source-cart-error'; error.setAttribute('role', 'alert'); error.hidden = true;
  atc.after(error);
  let count = 2, busy = false;
  const money = n => globalThis.BrowisoCheckout.money(n, config.currency, document.documentElement.lang || 'en');
  const sync = () => {
    choices.forEach(input => { input.checked = Number(input.value) === count; });
    cards.forEach(card => {
      const selected = Number(card.dataset.kitCount) === count;
      card.classList.toggle('is-selected', selected);
      card.querySelector('.source-offer__shades').hidden = !selected;
    });
    inputs.forEach(input => {
      input.value = shades[Number(input.dataset.kitIndex)];
      input.closest('.source-offer__shade').querySelector('[data-shade-swatch]').dataset.shadeSwatch = input.value;
      input.closest('.source-offer__shade').querySelector('[data-shade-selection]').textContent = input.selectedOptions[0]?.textContent?.trim() || '';
    });
    if (sticky) {
      sticky.querySelector('[data-sticky-price]').textContent = money(config.offerPrices[count - 1]);
      const label = count === 2 ? stickySubmit.dataset.duoLabel : stickySubmit.dataset.singleLabel;
      sticky.querySelector('[data-sticky-label]').textContent = label;
      stickySubmit.setAttribute('aria-label', label);
      sticky.querySelector('[data-sticky-deadline]').hidden = count !== 2;
      globalThis.marketkissOfferCountdownRefresh?.();
    }
  };
  choices.forEach(input => input.addEventListener('change', () => { count = Number(input.value); sync(); }));
  cards.forEach(card => card.addEventListener('click', event => {
    if (event.target.closest('select, a, button')) return;
    const next = Number(card.dataset.kitCount);
    if (next !== count) { count = next; sync(); }
  }));
  inputs.forEach(input => input.addEventListener('change', () => { shades[Number(input.dataset.kitIndex)] = input.value; sync(); }));
  const submit = async () => {
    if (busy) return;
    busy = true; error.hidden = true;
    if (stickyError) stickyError.hidden = true;
    const buttons = [...form.querySelectorAll('button'), ...(stickySubmit ? [stickySubmit] : [])];
    buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
    try {
      const before = await order.cart();
      const cart = await order.prepare(count, count < 3 && order.protections(before).length > 0, shades.slice(0, count), before);
      if (cart) document.dispatchEvent(new CustomEvent('browfi:cart-added', { detail: { cart } }));
    } catch (failure) {
      error.textContent = failure.message; error.hidden = false;
      if (stickyError) { stickyError.textContent = failure.message; stickyError.hidden = false; }
    }
    finally { busy = false; buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); }); }
  };
  form.addEventListener('submit', event => { event.preventDefault(); submit(); });
  stickySubmit?.addEventListener('click', submit);
  const syncSticky = () => {
    if (!sticky) return;
    const visible = atc.getBoundingClientRect().bottom < 0;
    sticky.style.transform = visible ? 'translateY(0)' : 'translateY(100%)';
    sticky.setAttribute('aria-hidden', String(!visible)); sticky.inert = !visible;
  };
  window.addEventListener('scroll', syncSticky, { passive: true });
  window.addEventListener('resize', syncSticky);
  const query = new URLSearchParams(location.search), variant = query.get('bundle_variant') || query.get('variant');
  const matched = variant && Object.entries(config.variantMap).find(([, id]) => String(id) === variant)?.[0].split('|');
  if (matched) { count = (config.enabledKitCounts || [1, 2, 3]).includes(matched.length) ? matched.length : 2; matched.slice(0, count).forEach((s, i) => shades[i] = s); }
  else if ((config.enabledKitCounts || [1, 2, 3]).includes(Number(query.get('kit')))) count = Number(query.get('kit'));
  sync(); syncSticky();
  const arrival = root.querySelector('[data-arrival-date]');
  const dispatch = root.querySelector('[data-pdp-dispatch-date]');
  const refreshArrival = () => {
    if (!arrival) return;
    const now = new Date();
    const date = days => globalThis.BrowisoCheckout.calendarDate(config.country, days, now);
    const format = new Intl.DateTimeFormat('en-AU', { timeZone: 'UTC', day: 'numeric', month: 'short' });
    arrival.textContent = format.format(date(6)) + ' – ' + format.format(date(9));
    if (dispatch) dispatch.textContent = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', weekday: 'short', month: 'short', day: 'numeric' }).format(date(1));
  };
  refreshArrival();
  window.addEventListener('pageshow', refreshArrival);
  window.setInterval(refreshArrival, 60000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshArrival(); });
  const track = root.querySelector('[data-demo-track]');
  if (track) {
    const previous = root.querySelector('[data-demo-prev]'), next = root.querySelector('[data-demo-next]');
    const updateArrows = () => { previous.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2; };
    const move = direction => track.scrollBy({ left: direction * (track.querySelector('video').getBoundingClientRect().width + 10), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    previous.addEventListener('click', () => move(-1)); next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateArrows, { passive: true }); window.addEventListener('resize', updateArrows); updateArrows();

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const region = track.closest('.mk-demo');
    let timer, resumeTimer, visible = false, hovered = false, touching = false;
    const stop = () => window.clearTimeout(timer);
    const schedule = () => {
      stop();
      if (!visible || hovered || touching || document.hidden || reducedMotion.matches || region.contains(document.activeElement)) return;
      timer = window.setTimeout(() => {
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          move(1);
        }
        schedule();
      }, 6500);
    };
    region.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
    region.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    region.addEventListener('pointerdown', () => { touching = true; stop(); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => window.addEventListener(name, () => {
      if (!touching) return;
      touching = false;
      schedule();
    }, { passive: true }));
    region.addEventListener('focusin', stop);
    region.addEventListener('focusout', () => window.setTimeout(schedule, 0));
    region.addEventListener('click', schedule);
    window.addEventListener('scroll', () => {
      stop();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(schedule, 350);
    }, { passive: true });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', schedule);
    new IntersectionObserver(entries => { visible = entries[0].intersectionRatio >= 0.4; schedule(); }, { threshold: [0, 0.4] }).observe(track);
    window.addEventListener('pagehide', () => { stop(); window.clearTimeout(resumeTimer); });
    window.addEventListener('pageshow', schedule);
  }
  root.querySelectorAll('.review-items-container splide-component').forEach(carousel => {
    const dots = [...carousel.querySelectorAll('.splide__pagination button')];
    if (dots.length < 2) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let timer;
    let visible = false;
    let hovered = false;
    let touching = false;
    let advancing = false;
    const stop = () => window.clearTimeout(timer);
    const schedule = () => {
      stop();
      if (!visible || hovered || touching || document.hidden || reducedMotion.matches || carousel.contains(document.activeElement)) return;
      timer = window.setTimeout(() => {
        const current = dots.findIndex(dot => dot.getAttribute('aria-current') === 'true');
        advancing = true;
        dots[(current + 1) % dots.length].click();
        advancing = false;
        schedule();
      }, 5000);
    };
    carousel.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; stop(); } });
    carousel.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    carousel.addEventListener('pointerdown', () => { touching = true; stop(); });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(name => carousel.addEventListener(name, () => { touching = false; schedule(); }));
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('focusout', () => window.setTimeout(schedule, 0));
    carousel.addEventListener('click', () => { if (!advancing) schedule(); });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener('change', schedule);
    new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, { threshold: 0.3 }).observe(carousel);
    window.addEventListener('pagehide', stop);
    window.addEventListener('pageshow', schedule);
  });
});


